// extracted by mini-css-extract-plugin
export default {"login":"Login_login__jJiFM","registration":"Login_registration__LTbF5","logo":"Login_logo__W+opJ","promo":"Login_promo__vAuF-"};